var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"benjamin-home"},[_c('section',{staticClass:"stat-bar"},[_c('StatBar')],1),_c('div',{staticClass:"outer-wrapper"},[_c('div',{staticClass:"page-container"},[_c('TitleBlock')],1),_c('AnimatedBar'),_c('Content')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }